export default __webpack_public_path__ + "static/media/mosquitera-corredera-card.35130ab0.png";